import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    ProjectGridObject, ProjectObject,
} from '@libs/types/src/mado/object-type/organization';
import { filterFrag } from './types/filter.types';
import { ProjectCreateInput, ProjectUpdateInput } from '@libs/types/src/mado/input-type/organization';

@Injectable({ providedIn: 'root' })
export class ProjectGqlService extends GqlServiceV2 {

    public getProjects(input: GridInput | null, frag: string): Promise<ProjectGridObject> {
        return this.query<ProjectGridObject>(
            `
                query($input: GridInput!) {
                    project {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createProject(input: ProjectCreateInput, frag: string) {
        return this.mutate<ProjectObject>(
            `
                mutation($input: ProjectCreateInput!) {
                    project {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateProject(input: ProjectUpdateInput, frag: string) {
        return this.mutate<ProjectObject>(
            `
                mutation($input: ProjectUpdateInput!) {
                    project {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
